import { render, staticRenderFns } from "./Nps.vue?vue&type=template&id=10ad58a7&scoped=true&"
import script from "./Nps.vue?vue&type=script&lang=js&"
export * from "./Nps.vue?vue&type=script&lang=js&"
import style0 from "./Nps.vue?vue&type=style&index=0&id=10ad58a7&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ad58a7",
  null
  
)

export default component.exports